import { Link } from "react-router-dom";
import { GeometricEye } from "./LogicImage";
import { useSEO } from "@/lib/useSEO";
import { DisciplineSwitcher } from "@/components/academy/DisciplineSwitcher";
import { useLogicUi } from "./logicUi";

export default function LogicFrame({ title, seoTitle, crumb, media, children, testid, draftGuard }) {
  const { ui } = useLogicUi();
  useSEO({ title: `${seoTitle || title} | Stoic Logic | StoicOs.ai Academy`, canonical: "https://stoicos.ai/academy/logic" });
  return (
    <main className="min-h-screen bg-ink px-6 sm:px-10 py-24" data-testid={testid}>
      <div className="max-w-4xl mx-auto">
        <DisciplineSwitcher active="logic" draftGuard={draftGuard} />
        <nav aria-label="Breadcrumb" className="text-[10px] tracking-[0.25em] uppercase text-[#8fa3c8] mb-10">
          <Link to="/academy" className="hover:text-gold">{ui.academyCrumb}</Link> / <Link to="/academy/logic" className="hover:text-gold">Stoic Logic</Link> / <span className="text-fog">{crumb || title}</span>
        </nav>
        <div className="flex items-center gap-4 mb-8"><GeometricEye media={media} size={36} /><h1 className="font-serif text-3xl sm:text-4xl text-bone">{title}</h1></div>
        {children}
      </div>
    </main>
  );
}
